import React from 'react'
import ReactDOM from 'react-dom'

import World from '@components/cases_map/world'

document.addEventListener('DOMContentLoaded', () => {
  const map = document.getElementById('cases_map');
  const data = document.getElementById('projects_data');
  const projects = JSON.parse(data.dataset.projects);
  ReactDOM.render(<World projects={projects} />, map);
}, { once: true });
